import { truncateString } from './utils'
import _ from 'lodash'

// text:内容 keepLength:保留长度
const truncateText = {
  // 指令元素插入到页面时执行
  componentUpdated(el, binding) {
    const symbol = '·'
    const { value } = binding
    const text = _.isString(value) ? value : _.get(value, 'text')
    const keepLength = _.get(value, 'keepLength') || 2
    const str = text && text.replaceAll(symbol, '')
    console.log(el, binding, text)

    const textContent = el.textContent
    const repText = el.innerHTML.replace(textContent, truncateString(text, keepLength))
    // 中文
    if (/^[\u2E80-\uFE4F]+$/.test(str)) {
      el.innerHTML = repText
      el.setAttribute('title', text)
    }
  }
}

// 自定义指令
const directives = {
  truncateText
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}
